import React, { useEffect, useState } from 'react';

import { Grid, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment';

import FilterPaper from '../../common/filter_paper';
import { SelectFieldMultipleWithMore } from '../../common/select_field';
import { DateRangePresetEnum } from './sales_analysis_utils';

const getPodOptionLabel = (pod) => `${ pod?.indoorPartner?.name } (${ pod?.description })`;

const SalesAnalysisFilters = ({ filters, setFilters, pods }) => {
    // selection is applied when the list closes, so charts are not reloaded on every click
    const [podIds, setPodIds] = useState(filters.podIds);

    useEffect(() => setPodIds(filters.podIds), [filters.podIds]);

    const onPresetChange = (_, preset) => {
        if (!preset) return;
        setFilters(prevState => ({ ...prevState, preset, ...DateRangePresetEnum[preset].range() }));
    };

    const onDateChange = (field) => (date) => {
        if (!date?.isValid()) return;
        setFilters(prevState => ({ ...prevState, preset: null, [field]: date }));
    };

    return (
        <FilterPaper title="Filtry analizy sprzedaży" sx={ { mb: 0 } }>
            <Grid container spacing={ 3 } alignItems="center">
                <Grid item xs={ 12 } lg={ 6 }>
                    <ToggleButtonGroup size="small" exclusive value={ filters.preset } onChange={ onPresetChange }>
                        {
                            Object.values(DateRangePresetEnum).map(preset => (
                                <ToggleButton key={ preset.value } value={ preset.value }>{ preset.label }</ToggleButton>
                            ))
                        }
                    </ToggleButtonGroup>
                </Grid>
                <Grid item xs={ 12 } sm={ 6 } lg={ 3 }>
                    <DatePicker
                        label="Od"
                        value={ filters.from }
                        maxDate={ filters.to }
                        onChange={ onDateChange('from') }
                        slotProps={ { textField: { size: 'small', fullWidth: true } } }
                    />
                </Grid>
                <Grid item xs={ 12 } sm={ 6 } lg={ 3 }>
                    <DatePicker
                        label="Do"
                        value={ filters.to }
                        minDate={ filters.from }
                        maxDate={ moment() }
                        onChange={ onDateChange('to') }
                        slotProps={ { textField: { size: 'small', fullWidth: true } } }
                    />
                </Grid>
                <Grid item xs={ 12 }>
                    <SelectFieldMultipleWithMore
                        size="small"
                        label="Pokaż dla punktów sprzedaży (domyślnie wszystkie)"
                        defaultOptions={ pods?.filter(pod => pod?.device?.serviceId != null).map(pod => ({ value: pod.id, label: getPodOptionLabel(pod) })) || [] }
                        extraOptions={ pods?.filter(pod => pod?.device?.serviceId == null).map(pod => ({ value: pod.id, label: `${ pod?.indoorPartner?.name } (Brak urządzenia)` })) || [] }
                        value={ podIds }
                        onChange={ event => setPodIds(event.target.value) }
                        onClose={ () => setFilters(prevState => ({ ...prevState, podIds })) }
                       
                    />
                </Grid>
            </Grid>
        </FilterPaper>
    );
};

export default SalesAnalysisFilters;
